import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

// Always show the scrolled (frosted) navbar styling — including on the homepage
useEffect(() => {
  setScrolled(true);
}, [location.pathname]);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const links = [
    { to: '/portraits', label: 'Portraits' },
    { to: '/events',    label: 'Events'    },
    { to: '/nature',    label: 'Nature'    },
    { to: '/about',     label: 'About'     },
  ];

  return (
    <header
      className={`navbar ${scrolled || menuOpen ? 'navbar--scrolled' : 'navbar--transparent'}`}
    >
      <Link to='/' className='navbar__logo'>
        Mike Tsai Photography {/* ← swap your name here */}
      </Link>

      {/* Desktop nav */}
      <nav className='navbar__links' aria-label='Main navigation'>
        {links.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className={`navbar__link ${location.pathname === to ? 'navbar__link--active' : ''}`}
          >
            {label}
          </Link>
        ))}
        <Link to='/contact' className='navbar__cta'>
          Book a Shoot
        </Link>
      </nav>

      {/* Mobile hamburger */}
      <button
        className='navbar__hamburger'
        onClick={() => setMenuOpen(o => !o)}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
      >
        <span />
        <span />
        <span />
      </button>

      {/* Mobile dropdown */}
      {menuOpen && (
        <nav className='navbar__mobile' aria-label='Mobile navigation'>
          {links.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`navbar__mobile-link ${location.pathname === to ? 'navbar__link--active' : ''}`}
            >
              {label}
            </Link>
          ))}
          <Link to='/contact' className='btn' style={{ marginTop: '0.5rem' }}>
            Book a Shoot
          </Link>
        </nav>
      )}
    </header>
  );
}
